export class Settings {
  // Global Settings
  public static APP_NAME = 'OSPIF';
  public static APP_VERSION = '0.0.1';


  // (+) EndPoints
  public static endPoints = {
    files: '/files',
    users: '/users',
    accounts: '/accounts',
    places: '/places',
    movementsIncomes: '/places/last-income'
  };

  public static storage = {
    user: 'ospif.user',
  };

  public static url = {
    admUrl: 'http://localhost:4200'    
  }

  //Key and where for endpoint
  public static key = '?key=2b94c779b163a0ed713ccf6fbec87a01&';
  public static whereAccount = 'parent_place_id=';
  public static placeId = 'place_id=';

  // (+) Keys
  public static keys = {
    googleMaps: 'AIzaSyBeyOW3a84ySROuFpiEw56T3jvdtzhahts'
  };
  // (-) Keys

  public static colors = ['#333FEC','#EC335F', '#1D8833', '#F1E915', '#EC5F33','#7B169E', '#1593E6','#15E6A6', '#F5C751', '#F178F1']; 

  public static endPointsMethods = {
    users: {
      login: '/login',
      changePassword: '/changePassword',
      recoveryPasswordUsername: '/recoveryPassword/username'
    },
    adherents : {
      getAdherentsOfAffiliate: '/getAdherentsOfAffiliate',
      addAdherent: '/addAdherent'
    },
    affiliates : {
      credentialCuil: '/credential/cuil'
    }
  };

  public static roles = {
    user: 'user',
  };

  public static exp = {
    mza: ['manzana', 'mza', 'm', 'jardines'],
    lote: ['lote', 'lte', 'l', 'casa'] 
  }

  public static map = {
    mapIndicationsUrl: function(userPos, destinationPos) { return `https://www.google.com/maps/dir/${userPos.lat},${userPos.lng}/${destinationPos.lat},${destinationPos.lng}/` }
  }
  public static isTesting = false;
  public static  test = [
    {
      id: "00000000-0000-0009-0003-000000000001",
      name: "Guardia Principal",
      group: "guards",
      color: '',
      address: {
        street: "Guardia 1, Los Árboles",
        city: "Córdoba",
        state: "Córdoba",
        country: "Argentina",
        zipcode: "5000",
        position: [ -31.370083, -64.283989 ]
      },
    },
    {
      id: "00000000-0000-0009-0003-000000000002",
      name: "Guardia 2",
      group: "guards",
      color: '',
      address: {
        street: "Guardia 1, Los Árboles",
        city: "Córdoba",
        state: "Córdoba",
        country: "Argentina",
        zipcode: "5000",
        position: [ -31.367499, -64.281469 ]
      },
    },
    {
      id: "00000000-0000-0009-0003-000000000003",
      name: "Guardia 3",
      group: "guards",
      color: '',
      address: {
        street: "Guardia 1, Los Árboles",
        city: "Córdoba",
        state: "Córdoba",
        country: "Argentina",
        zipcode: "5000",
        position: [ -31.365613, -64.285608 ]
      },
    },
    {
      id: "00000000-0000-0009-0003-000000000004",
      name: "Guardia 4",
      group: "guards",
      color: '',
      address: {
        street: "Guardia 1, Los Árboles",
        city: "Córdoba",
        state: "Córdoba",
        country: "Argentina",
        zipcode: "5000",
        position: [ -31.366850, -64.286406 ]
      }
    }
  ];
}
